import { api } from 'src/api/axios';

export interface FeedbackResponse {
  rating: number;
  message: string;
}

export interface FeedbackEnabledResponse {
  enabled: boolean;
}

export const feedbackService = {
  isEnabled: async (): Promise<boolean> => {
    try {
      const response = await api.get<FeedbackEnabledResponse>(
        '/user/feedback/enabled'
      );
      return response.data?.enabled === true;
    } catch {
      return false;
    }
  },

  get: async (): Promise<FeedbackResponse | null> => {
    try {
      const response = await api.get('/user/feedback');
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  submit: async (rating: number, message?: string): Promise<void> => {
    await api.post('/user/feedback', { rating, message });
  },
};
